@if (currentUser) {
<div class="navbar"
     [ngClass]="{
       dev: isDev,
     }">
  <img class="logo"
       src="logo.svg" />

  <div class="tabs">
    <a class="tab"
       *ngFor="let tab of tabs"
       [routerLink]="tab.disabled ? null : tab.routerLink"
       routerLinkActive="active"
       [ngClass]="{
         disabled: tab.disabled,
         dev: isDev,
       }">
      <span class="pi"
            [ngClass]="tab.icon">
      </span>

      <span>{{ tab.label }}</span>
    </a>
  </div>

  <div (click)="openNotifications()" class="circle notify">
    <i class="pi pi-bell"></i>
    <p-tag class="badge"
           severity="danger"
           rounded
           [value]="unreadNotifications">
    </p-tag>
  </div>
  <div (click)="menu.toggle($event);"
       class="user">
    <div *ngIf="initials"
         class="circle"
         [ngClass]="{
           dev: isDev
         }">
      {{ initials }}

      <p-tag *ngIf="isDev"
             class="dev-tag"
             severity="info"
             [value]="environmentName"
             [rounded]="true" />
    </div>

    <div class="text-sm white-space-nowrap">
      {{ email }}

      <span class="app-bold"
            *ngIf="currentModule === 'kms' && selectedYardName">
        ({{ selectedYardName }})
      </span>
    </div>

    <i class="pi pi-angle-down"></i>
  </div>
</div>

<p-menu #menu
        [popup]="true">
  <ng-template #start>
    <div class="menu">
      <div class="menu-items">
        <div class="my-1">Change module</div>

        <a class="menu-item"
           *ngFor="let menuItem of menuItems"
           (click)="menuItemClick()"
           [routerLink]="menuItem.routerLink"
           routerLinkActive="active">
          <div class="label">
            <div class="circle">
              <i class="pi"
                 [ngClass]="menuItem.icon">
              </i>
            </div>

            <div>{{ menuItem.label }}</div>
          </div>

          <div class="info active">
            <div>Active</div>
            <i class="pi pi-check-circle"></i>
          </div>
        </a>
      </div>

      <div class="hr"></div>

      <div class="menu-items">
        <a class="menu-item"
           (click)="confirmPasswordReset()">
          <div class="label">
            <i class="pi pi-user"></i>
            <div>Change password</div>
          </div>
        </a>

        <a class="menu-item"
           (click)="logout()"
           routerLink="/login">
          <div class="label">
            <i class="pi pi-sign-out"></i>
            <div>Logout</div>
          </div>
        </a>
      </div>

      <div *ngIf="uiVersion"
           class="version">
        UI version: {{ uiVersion }}
      </div>

      <div *ngIf="apiVersion"
           class="version">
        API version: {{ apiVersion }}
      </div>
    </div>
  </ng-template>
</p-menu>
}
